export const API_ENDPOINTS = {
  BASE_URL: "https://clear-jade-scarab.cyclic.app",
  TUTORS: "/api/v1/tutors",
  CONTENTS:"/api/v1/contents",
  IMAGES: "/img/",
  TEST_AUTH: "/api/v1/tutors/testAuth",
  REGISTER: "/api/v1/auth/register",
  LOGIN: "/api/v1/auth/login",
  LOGOUT: "/api/v1/auth/logout",
  REFRESH: "/api/v1/auth/refresh",
  REVIEWS: "/api/v1/reviews",
  CONTACTS: "/api/v1/contact",
  STATISTICS: "/statistics",
};
